import { useState, useMemo } from 'react';
import './ToolStyles.css';

const RegexTester = () => {
    const [pattern, setPattern] = useState('');
    const [flags, setFlags] = useState('g');
    const [testText, setTestText] = useState('');
    const [error, setError] = useState('');

    const matches = useMemo(() => {
        setError('');
        if (!pattern || !testText) return null;
        try {
            const regex = new RegExp(pattern, flags);
            const results: { index: number; text: string }[] = [];
            let match: RegExpExecArray | null;
            while ((match = regex.exec(testText)) !== null) {
                results.push({ index: match.index, text: match[0] });
                if (!flags.includes('g')) break;
            }
            return results;
        } catch (e) {
            setError((e as Error).message);
            return null;
        }
    }, [pattern, flags, testText]);

    const highlightedText = useMemo(() => {
        if (!testText || !matches || matches.length === 0) return null;
        const parts: { text: string; highlight: boolean }[] = [];
        let lastIndex = 0;
        for (const m of matches) {
            if (m.index > lastIndex) {
                parts.push({ text: testText.slice(lastIndex, m.index), highlight: false });
            }
            parts.push({ text: m.text, highlight: true });
            lastIndex = m.index + m.text.length;
        }
        if (lastIndex < testText.length) {
            parts.push({ text: testText.slice(lastIndex), highlight: false });
        }
        return parts;
    }, [testText, matches]);

    return (
        <div className="tool-container">
            <div className="input-group">
                <label className="input-label">正则表达式</label>
                <div style={{ display: 'flex', gap: 8 }}>
                    <span style={{
                        display: 'flex', alignItems: 'center', padding: '0 4px',
                        fontSize: 18, color: 'var(--text-tertiary)'
                    }}>/</span>
                    <input
                        className="tool-input"
                        value={pattern}
                        onChange={(e) => setPattern(e.target.value)}
                        placeholder="例如: \d+"
                        style={{ flex: 1 }}
                    />
                    <span style={{
                        display: 'flex', alignItems: 'center', padding: '0 4px',
                        fontSize: 18, color: 'var(--text-tertiary)'
                    }}>/</span>
                    <input
                        className="tool-input"
                        value={flags}
                        onChange={(e) => setFlags(e.target.value)}
                        placeholder="g"
                        style={{ width: 60 }}
                    />
                </div>
            </div>

            <div className="input-group">
                <label className="input-label">测试文本</label>
                <textarea
                    className="tool-textarea"
                    value={testText}
                    onChange={(e) => setTestText(e.target.value)}
                    rows={6}
                    placeholder="输入要测试的文本..."
                />
            </div>

            {error && <div className="error-message">{error}</div>}

            {highlightedText && (
                <div className="output-group">
                    <label className="output-label">
                        匹配结果（{matches?.length || 0} 处匹配）
                    </label>
                    <pre className="tool-output" style={{ whiteSpace: 'pre-wrap', lineHeight: 1.8 }}>
                        {highlightedText.map((part, i) =>
                            part.highlight ? (
                                <mark key={i} style={{
                                    backgroundColor: 'var(--accent-soft)',
                                    color: 'var(--accent)',
                                    fontWeight: 600,
                                    borderRadius: 3,
                                    padding: '1px 2px',
                                }}>{part.text}</mark>
                            ) : (
                                <span key={i}>{part.text}</span>
                            )
                        )}
                    </pre>
                </div>
            )}

            {matches && matches.length === 0 && testText && pattern && (
                <div className="info-text">未找到匹配项</div>
            )}
        </div>
    );
};

export default RegexTester;
